import { render, staticRenderFns } from "./efficiency.vue?vue&type=template&id=f2400a66&scoped=true&"
import script from "./efficiency.vue?vue&type=script&lang=js&"
export * from "./efficiency.vue?vue&type=script&lang=js&"
import style0 from "./efficiency.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./efficiency.vue?vue&type=style&index=1&id=f2400a66&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2400a66",
  null
  
)

export default component.exports